import {Vector2, Color, MirroredRepeatWrapping, ClampToEdgeWrapping, RepeatWrapping} from "three";

// src texture ref to material properties
export const mapTextureNames = () => {
  
  const textureNames = new Map();
  
  // json name = name + tiling
  textureNames.set('srcAlpha', ['alphaMap', false]);
  textureNames.set('srcAo', ['aoMap', false]);
  textureNames.set('srcEmissive', ['emissiveMap', false]);
  textureNames.set('srcEnviro', ['envMap', false]);
  textureNames.set('srcLightMap', ['lightMap', false]);
  textureNames.set('srcDiffuse', ['map', true]);
  textureNames.set('srcMetalness', ['metalnessMap', true]);
  textureNames.set('srcNormal',[ 'normalMap', true]);
  textureNames.set('srcRoughness', ['roughnessMap', true]);
  
  return textureNames;
  
};

/*
 --------------------------------------------------------
*/
export const textureWrappingNames = () => {
  
  // wrapping will only be applied if "mapTextureName" is set to true
  
  // "materialProps": {
  //   "wrap": "repeat", "clamp" or "mirror",
  //   "textureTiling": 8,
  //},
  
  // if wrap is omitted - will default to RepeatWrapping
  // if textureTiling is omitted - will default x1
  
  const wrapName = new Map();
  
  wrapName.set('repeat', RepeatWrapping);
  wrapName.set('clamp', ClampToEdgeWrapping);
  wrapName.set('mirror', MirroredRepeatWrapping);
  
  return wrapName;
  
};

/*
 --------------------------------------------------------
*/
// src texture ref to material properties
export const mapMaterialProps = () => {
  
  const materialProps = new Map();
  
  materialProps.set('normalScale', (val) => {
    return new Vector2(val, val);
  });
  materialProps.set('color', (val) => {
    return new Color().setHex(val);
  });
  
  return materialProps;
  
};
